import { deepEqual } from "./object";

export function mergeArraysFromItemFields(array, key) {
	if (!array || array.legnth === 0 || !key) return [];
	let merged = [];
	array.forEach(element => {
		merged.push(...element[key]);
	});
	return merged;
}

export function isDiff(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return true;
	}
	return (
		arr1.some(it => !arr2.includes(it))
	);
}

export function isDeepDiff(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return true;
	}
	return (
		arr1.some(it => !arr2.find(it2 => deepEqual(it, it2)))
	);
}

export function isObjectArray(arr) {
	if (!arr) return false;
	return arr.every(item => typeof item === 'object');
}

export function max(arr, field) {
	let max = null;
	arr?.forEach(item => {
		if (max == null || max[field] < item[field]) {
			max = item;
		}
	});
	return max;
}

export function min(arr, field) {
	let max = null;
	arr?.forEach(item => {
		if (max == null || max[field] > item[field]) {
			max = item;
		}
	});
	return max;
}

export function countFieldArray(array, field) {
	return array?.reduce((prev, cur, idx) => {
		return prev + (cur[field]?.length ?? 0);
	}, 0)
}